import React from "react";
import {Modal} from "react-bootstrap";
import Button from "react-bootstrap/Button";

let img_tabella_ai = require("../../assets/home/tabella/24.png");
let img_tabella_tradizionale = require("../../assets/home/tabella/25.png");

function ModelMushroomGrowth(params = false) {

    return (
        <Modal show={params.show} onHide={() => {
            if (params.onHide !== null) params.onHide()
        }}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <h4>Scegli <b>la tabella da consultare</b></h4>
                <div style={{display: "flex", justifyContent: "space-between", gap: 16}}>
                    <div>
                        <img className="modal-image" src={img_tabella_ai} alt="Card image cap"/>
                        <Button className={"btn-orange"} style={{fontWeight: "bold", marginTop: 8}} href={"/ai"}>TABELLA
                            INTELLIGENTE</Button>
                    </div>
                    <div>
                        <img className="modal-image" src={img_tabella_tradizionale} alt="Card image cap"/>
                        <Button className={"btn-orange"} style={{fontWeight: "bold", marginTop: 8}}
                                href={"/mushroom-growth-table"}>TABELLA
                            ORDINARIA</Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ModelMushroomGrowth;